
export const  articles = [
    {
      id: 1,
      articleName: "Scale your testing capacity",
      path: "/src/blog/testArticle1",
    },
    {
      id: 2,
      articleName: "Increase product quality",
      path: "/src/blog/testArticle2",
    },
    {
      id: 3,
      articleName: "Achieve faster time-to-market",
      path: "/src/blog/testArticle3",
    },
    {
      id: 4,
      articleName: "Save costs and launch quickly",
      path: "/src/blog/developArticle4",
    },
    {
      id: 5,
      articleName: "Full control over development",
      path: "/src/blog/developArticle5",
    },
    {
      id: 6,
      articleName: "Support after launch",
      path: "/src/blog/developArticle6",
    },
    {
      id: 7,
      articleName: "Mobile Applications Testing",
      path: "/src/blog/testArticle4",
    },
    {
      id: 8,
      articleName: "Desktop Testing",
      path: "/src/blog/testArticle6",
    },
    {
      id: 9,
      articleName: "Web Applications Testing",
      path: "/src/blog/testArticle5",
    },
    {
      id: 10,
      articleName: "Manual Testing",
      path: "/src/blog/testArticle7",
    },
    {
      id: 11,
      articleName: "Automated Testing",
      path: "/src/blog/testArticle8",
    },
    {
      id: 12,
      articleName: "Web Security Testing",
      path: "/src/blog/testArticle9",
    },
    {
      id: 13,
      articleName: "Web Applications Testing",
      path: "/src/blog/testArticle5",
    },
    {
      id: 14,
      articleName: "Mobile App Development",
      path: "/src/blog/developArticle1",
    },
    {
      id: 15,
      articleName: "Web Design & Development",
      path: "/src/blog/developArticle2",
    },
    {
      id: 16,
      articleName: "Database Development",
      path: "/src/blog/developArticle3",
    },
    {
      id: 17,
      articleName: "About Us",
      path: "/src/pages/aboutus",
    },
    {
      id: 18,
      articleName: "Website Privacy & Policy",
      path: "/src/pages/policy",
    },
  ];
